import {
  Configuration,
  CustomersApi,
  GetAllCustomersRequest,
  ViewCustomer
} from "collins-js-sdk";
import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler } from "../errorHandler";

/**
 * Get the customer from the API
 * @returns
 */
export const fetchCustomersFromAPI = async (
  params: GetAllCustomersRequest
): Promise<ViewCustomer[]> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  const config = new Configuration({
    accessToken: token,
    basePath: environmentVars?.COLLINS_API_BASE_URL
  });

  try {
    const apiResponse = (await new CustomersApi(config).getAllCustomers(params))
      .customers;
    return apiResponse ?? [];
  } catch (error) {
    errorHandler(error, "Error fetching customers");

    return [];
  }
};
